import React from 'react';
import { Link } from 'react-router-dom';

export const Hero = () => {
  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img 
          src="/lovable-uploads/432becec-fde8-42af-9c53-af4da94a8b43.png"
          alt="Happy family enjoying time together under colorful umbrellas" 
          className="w-full h-full object-cover rounded-3xl opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A1F2C]/30 to-[#1A1F2C] rounded-3xl" />
      </div>

      {/* Header Container - Now inline with dark background */}
      <div className="relative flex justify-between items-center px-6 py-4">
        <img 
          src="/lovable-uploads/08547d9d-5391-4141-9c40-25f23185ecc9.png"
          alt="Trade Co Financial Restructuring Services"
          className="h-16 w-auto"
        />
        <Link 
          to="/login" 
          className="inline-flex items-center px-6 py-2 text-sm font-medium text-primary bg-white/90 hover:bg-white rounded-lg border border-primary/20 transition-all duration-200 shadow-sm hover:shadow-md"
        >
          Login
        </Link>
      </div>
      
      <div className="relative text-center space-y-8 animate-fadeIn max-w-4xl mx-auto py-20 mt-8">
        <div className="inline-flex items-center justify-center px-4 py-2 mb-6 text-sm font-medium rounded-full bg-primary/10 text-primary animate-float backdrop-blur-sm border border-primary/20 shadow-lg">
          Registered South African Law Firm | Over 15 Years of Excellence
        </div>
        
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white drop-shadow-lg">
          Professional
          <span className="bg-gradient-to-r from-primary to-primary/70 text-transparent bg-clip-text drop-shadow-lg">
            {" "}Financial Realignment Services
          </span>
        </h1>
        
        <p className="text-lg md:text-xl text-gray-100 leading-relaxed max-w-3xl mx-auto font-medium drop-shadow">
          Transform your financial future with South Africa's trusted legal experts. Our attorneys provide swift, legally-protected financial realignment solutions that put you back in control.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
          <Link 
            to="/register" 
            className="w-full sm:w-auto px-8 py-3 text-lg font-semibold text-white bg-primary hover:bg-primary/90 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Register Now
          </Link>
          <Link 
            to="/login" 
            className="w-full sm:w-auto px-8 py-3 text-lg font-semibold text-primary bg-white hover:bg-gray-50 rounded-lg border-2 border-primary transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Calculate Your Savings
          </Link>
        </div>

        <div className="flex flex-wrap justify-center gap-6 pt-6">
          <div className="flex items-center space-x-2 text-sm text-white font-semibold bg-black/40 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20 shadow-lg hover:bg-black/50 transition-all">
            <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <span className="drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]">Legally Protected Process</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-white font-semibold bg-black/40 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20 shadow-lg hover:bg-black/50 transition-all">
            <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]">Swift Financial Relief</span>
          </div>
          <div className="flex items-center space-x-2 text-sm text-white font-semibold bg-black/40 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20 shadow-lg hover:bg-black/50 transition-all">
            <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span className="drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]">Confidential Consultation</span>
          </div>
        </div>
      </div>
    </div>
  );
};